import React from 'react';

import logoFooter from 'assets/images/new-login/logo-footer.svg';
import iconFacebook from 'assets/images/new-login/face.svg';
import iconInstagram from 'assets/images/new-login/insta.svg';
import iconLinkedin from 'assets/images/new-login/linkedin.svg';
import iconYoutube from 'assets/images/new-login/youtube.svg';

import {
  Container,
  InfoBand,
  InfoContent,
  BrandColumn,
  BrandLogo,
  SocialList,
  SocialLink,
  ContactColumn,
  ContactTitle,
  ContactList,
  ContactItem,
  ContactLabel,
  ContactValue,
  LegalBand,
  LegalLink,
  Copyright,
  CopyrightTitle,
  CopyrightText,
} from './styles';

type SocialData = {
  name: string;
  icon: string;
  href: string;
};

type ContactData = {
  label: string;
  value: string;
  href: string;
};

const socials: SocialData[] = [
  {
    name: 'Instagram',
    icon: iconInstagram,
    href: 'https://www.instagram.com/ultragazoficial/',
  },
  {
    name: 'Facebook',
    icon: iconFacebook,
    href: 'https://www.facebook.com/ultragazoficial/',
  },
  {
    name: 'LinkedIn',
    icon: iconLinkedin,
    href: 'https://www.linkedin.com/company/ultragaz/mycompany/',
  },
  {
    name: 'YouTube',
    icon: iconYoutube,
    href: 'https://www.youtube.com/user/UltragazBrasilgas',
  },
];

const contacts: ContactData[] = [
  {
    label: 'Central atendimento',
    value: '0800 591 3923',
    href: 'tel:08005913923',
  },
  {
    label: 'WhatsApp Pós-Vendas',
    value: '0800 591 3923',
    href: 'https://wa.me/558005913923',
  },
  {
    label: 'WhatsApp Central Comercial',
    value: '0800 591 3923',
    href: 'https://wa.me/558005913923',
  },
  {
    label: 'E-mail Pós-Vendas',
    value: 'atendimentoaocliente@ultragaz.com.br',
    href: 'mailto:atendimentoaocliente@ultragaz.com.br',
  },
];

const PRIVACY_URL =
  'https://www.ultragaz.com.br/institucional/politica-de-privacidade';

const AuthFooter: React.FC = () => {
  return (
    <Container>
      <InfoBand>
        <InfoContent>
          <BrandColumn>
            <BrandLogo src={logoFooter} alt="Ultragaz" />
            <SocialList>
              {socials.map((social) => (
                <SocialLink
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={social.name}
                >
                  <img src={social.icon} alt="" />
                </SocialLink>
              ))}
            </SocialList>
          </BrandColumn>

          <ContactColumn>
            <ContactTitle>Contato</ContactTitle>
            <ContactList>
              {contacts.map((contact) => (
                <ContactItem key={contact.label}>
                  <ContactLabel>{contact.label}</ContactLabel>
                  <ContactValue href={contact.href}>
                    {contact.value}
                  </ContactValue>
                </ContactItem>
              ))}
            </ContactList>
          </ContactColumn>
        </InfoContent>
      </InfoBand>

      <LegalBand>
        <LegalLink href={PRIVACY_URL} target="_blank" rel="noreferrer">
          Politicas e termos de uso
        </LegalLink>
        <Copyright>
          <CopyrightTitle>
            Ultragaz® Todos os direitos reservados
          </CopyrightTitle>
          <CopyrightText>Desenvolvido por Ultragaz</CopyrightText>
        </Copyright>
      </LegalBand>
    </Container>
  );
};

export default AuthFooter;
